import React, { useEffect } from "react"
import queryString from "query-string"
import { useHistory, useLocation } from "react-router-dom"
import { decodeBase64ToJson } from "lib/helper"
import { useStore } from "hooks"
import { session } from "store"
import AppLoader from "components-old/ui/AppLoader"

interface AuthAldeiaFromKinboxProps {}

function AuthAldeiaFromKinbox(props: AuthAldeiaFromKinboxProps) {
  const location = useLocation()
  const history = useHistory()
  const { loginFromToken } = useStore(session)

  useEffect(() => {
    const query = queryString.parse(location.search)

    if (query.tokenized) {
      const tokenized = decodeBase64ToJson(query.tokenized as string) as { token: string; workspaceId: string }
      console.log(tokenized)
      loginFromToken({
        token: tokenized.token,
        workspaceId: tokenized.workspaceId,
      }).then(() => {
        history.push("/")
      })
    }
  }, [])

  return <AppLoader />
}

export default AuthAldeiaFromKinbox
